import { render, staticRenderFns } from "./_loader.vue?vue&type=template&id=08fea50d"
import script from "./_loader.vue?vue&type=script&lang=js"
export * from "./_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports